module.exports = __webpack_public_path__ + "img/tzj_jbgsBanner.324f65d.png";